import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStance = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 73.551,
	height: 34.802,
	viewBox: "0 0 73.551 34.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_175",
		"data-name": "Group 175",
		transform: "translate(0.5 0.5)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_50",
				"data-name": "Rectangle 50",
				width: 72.551,
				height: 33.802,
				fill: "none",
				stroke: "#040505",
				strokeWidth: 1,
				opacity: 0
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_348",
				"data-name": "Path 348",
				d: "M800.067,389.408",
				transform: "translate(-792.197 -374.215)",
				fill: "none",
				stroke: "#040505",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 4
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_174",
				"data-name": "Group 174",
				transform: "translate(17.9 2.845)",
				children: [
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_172",
						"data-name": "Group 172",
						transform: "translate(0 5.459)",
						children: [
							/* @__PURE__ */ _jsx("path", {
								id: "Path_349",
								"data-name": "Path 349",
								d: "M858.009,386.789c0,.29.019.551.043.8a1.253,1.253,0,0,1,.709.208c.352.235.693.461,1.025.681l.494-.506c.773-.873,2.909-3.692,3.118-5.8.108-1.085-.2-1.666-.426-1.791-.035-.019-.092-.051-.216.048-.3.239-.642.518-1.006.816a38.806,38.806,0,0,1-3.736,2.826C858.01,385.1,858.006,386.125,858.009,386.789Z",
								transform: "translate(-837.456 -378.243)",
								fill: "none"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_350",
								"data-name": "Path 350",
								d: "M844.289,396.785c-.007.007-.015.013-.022.021l.005,0C844.278,396.8,844.283,396.791,844.289,396.785Z",
								transform: "translate(-830.968 -386.001)",
								fill: "none"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_351",
								"data-name": "Path 351",
								d: "M837.492,396.992a10.393,10.393,0,0,1,.784-1.823,2.126,2.126,0,0,1,1.007-.908c.05-.268.129-.74.247-1.56a9.137,9.137,0,0,0,.058-1.426c-.394.082-.779.161-1.141.235.122.183.26.373.394.54a1.058,1.058,0,0,1,.2.912,5.768,5.768,0,0,1-2.39,3.384,6.252,6.252,0,0,1-2.554.762s-.01,0-.019.014a7.407,7.407,0,0,0,.582,1.491,17.27,17.27,0,0,0,1.594,2.6,2.381,2.381,0,0,1,.412-.665A19.142,19.142,0,0,1,837.492,396.992Z",
								transform: "translate(-826.156 -383.4)",
								fill: "none"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_352",
								"data-name": "Path 352",
								d: "M855.719,392.794a2.278,2.278,0,0,0-1.974-1.62c-.39-.044-.838-.089-1.317-.136a22.938,22.938,0,0,1-5.283-.887c-.7-.347-2.083-1.185-3.943-2.386l.24-.246c.137-.154,3.353-3.8,3.673-7.033.178-1.8-.389-3.239-1.517-3.854a2.275,2.275,0,0,0-2.541.25c-.308.245-.657.531-1.03.837-.693.567-1.566,1.282-2.384,1.89,0-.707.008-1.189.008-1.2a1.056,1.056,0,0,0-1.048-1.064H838.6a1.056,1.056,0,0,0-1.056,1.048c0,.023-.008,1.135-.016,2.482,0,.711-.008,1.485-.01,2.2s0,1.362,0,1.835a9.446,9.446,0,0,0,.5,3.1c-.006.034-.012.065-.018.1a3.363,3.363,0,0,1-2.021.266,4.339,4.339,0,0,1-1.547-.856c-.036-.03-.078-.049-.115-.076.067-.378.136-.86.226-1.489a12.578,12.578,0,0,0,.064-2.177c-.029-.718-.09-1.456-.161-2.127-.137-1.291-.3-2.322-.317-2.41a1.056,1.056,0,0,0-2.083.342c.084.519.22,1.478.324,2.519-.979.206-1.874.387-2.482.508a1.256,1.256,0,0,0-.648.354c-.192-.157-.389-.329-.594-.533-1.311-1.3-4.542-4.581-4.574-4.614a1.056,1.056,0,0,0-1.5,1.482c.033.033,3.271,3.32,4.591,4.63a9.466,9.466,0,0,0,2.545,1.844c.02.028.037.054.058.083a3.356,3.356,0,0,1-1.241,1.616,4.307,4.307,0,0,1-1.7.489h0c-.047,0-.09.021-.135.028-.221-.315-.512-.7-.893-1.213a30.57,30.57,0,0,0-5.04-4.454,1.056,1.056,0,0,0-1.232,1.715,28.057,28.057,0,0,1,4.582,4c.5.663.774,1.052.929,1.277a2.135,2.135,0,0,0-.069,1.355,10.493,10.493,0,0,0,.735,1.842,19.092,19.092,0,0,0,1.929,3.1,6.289,6.289,0,0,0,.8,2.226,1.056,1.056,0,0,0,.792.593,3.265,3.265,0,0,0,.477.031,5.6,5.6,0,0,0,1.377-.186,8.545,8.545,0,0,0,2.464.569c1.423.125,4.384.158,7.12.158,2.936,0,5.613-.039,5.847-.042.205-.012,5.06-.318,7.57-2.375C855.464,395.445,856.081,394.026,855.719,392.794Zm-16.09-10.617a38.827,38.827,0,0,0,3.736-2.826c.364-.3.705-.577,1.006-.816.125-.1.182-.067.216-.048.23.125.534.706.426,1.791-.209,2.112-2.345,4.931-3.118,5.8l-.494.506c-.333-.219-.673-.445-1.025-.681a1.252,1.252,0,0,0-.709-.207c-.024-.248-.043-.509-.043-.8C839.621,384.236,839.625,383.214,839.629,382.177Zm-12.056,9.392a7.4,7.4,0,0,1-.582-1.491c.009-.013.016-.014.019-.014a6.255,6.255,0,0,0,2.554-.762,5.769,5.769,0,0,0,2.39-3.384,1.058,1.058,0,0,0-.2-.912c-.134-.167-.271-.357-.394-.54.362-.074.747-.153,1.141-.235a9.136,9.136,0,0,1-.058,1.426c-.118.82-.2,1.292-.247,1.56a2.126,2.126,0,0,0-1.006.908,10.393,10.393,0,0,0-.784,1.823,19.144,19.144,0,0,0-.828,3.557,2.38,2.38,0,0,0-.412.665A17.284,17.284,0,0,1,827.573,391.569Zm4.819-4.431c-.006.006-.011.013-.017.019l0,0Zm20.336,7.82c-1.642,1.345-5.145,1.828-6.309,1.9-.095,0-9.286.13-12.432-.088l-.275-.021a5.882,5.882,0,0,1-2.5-.74,3.871,3.871,0,0,1-.411-.275c.133-.338.259-.631.334-.777l.122-.1a1.059,1.059,0,0,0,.386-.749,15.805,15.805,0,0,1,.773-3.5,7.36,7.36,0,0,1,.643-1.465.023.023,0,0,1,.023,0h0a6.268,6.268,0,0,0,2.345,1.267,4.684,4.684,0,0,0,2.166.027,6.546,6.546,0,0,0,1.917-.732,1.056,1.056,0,0,0,.5-.784c.025-.216.061-.448.1-.661.492.326,1.031.679,1.582,1.038,1.7,1.106,3.536,2.254,4.512,2.738,1.167.578,3.32.829,6.013,1.1.468.046.906.089,1.286.133.157.018.176.081.187.119C853.767,393.642,853.571,394.267,852.728,394.958Z",
								transform: "translate(-819.071 -376.355)",
								fill: "#040505",
								opacity: .3
							})
						]
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_173",
						"data-name": "Group 173",
						transform: "translate(15.964 6.857)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_353",
							"data-name": "Path 353",
							d: "M857.713,379.985a1.091,1.091,0,0,0-1.376-.942,9.357,9.357,0,0,0-1.654.662,16.552,16.552,0,0,0-3.241,2.075l-.3-.03a10.321,10.321,0,0,0-1.807.7,5.625,5.625,0,0,0,1.6,4.137c1.891,2.253,8.981,9.141,8.981,9.141s3.51,3.122,6.435,3.411c2.566.254,3.513-1.294,2.673-2.35-1.266-1.591-3.639-4.29-4.118-5.711-.531-1.573-1.414-5.879-1.82-7.918-.131-.659-2.018.844-2.018.844a4.821,4.821,0,0,1-2.724-1.892A5.325,5.325,0,0,1,857.713,379.985Z",
							transform: "translate(-849.316 -379.003)",
							fill: "#fff"
						})
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_354",
						"data-name": "Path 354",
						d: "M867.672,381.6l-2.729-2.257-1.247-2.79,4.346-2.735,3.74,3.1Z",
						transform: "translate(-840.141 -369.7)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_355",
						"data-name": "Path 355",
						d: "M868.388,390c-.244-.306-.528-.653-.832-1.024a22.961,22.961,0,0,1-3.112-4.367c-.518-1.536-1.42-5.957-1.785-7.786a1.255,1.255,0,0,0-.355-.648c.157-.192.329-.39.533-.6,1.319-1.327,4.613-4.573,4.614-4.574a1.056,1.056,0,1,0-1.482-1.5c-.034.033-3.32,3.271-4.63,4.591a9.463,9.463,0,0,0-1.844,2.544l-.084.059a3.356,3.356,0,0,1-1.616-1.241,4.242,4.242,0,0,1-.489-1.7c0-.046-.021-.09-.028-.135.315-.221.7-.511,1.214-.893a30.505,30.505,0,0,0,4.453-5.041,1.056,1.056,0,0,0-1.714-1.232,28.023,28.023,0,0,1-4,4.583c-.662.5-1.052.774-1.277.928a2.132,2.132,0,0,0-1.356-.07,10.422,10.422,0,0,0-1.842.735,19.113,19.113,0,0,0-3.1,1.929,6.288,6.288,0,0,0-2.226.8,1.058,1.058,0,0,0-.593.791,6.568,6.568,0,0,0,1.831,4.979c1.9,2.269,8.763,8.937,9.088,9.252.154.137,3.8,3.353,7.033,3.673q.328.033.639.032a3.469,3.469,0,0,0,3.215-1.549A2.28,2.28,0,0,0,868.388,390Zm-12.03-17.924a1.062,1.062,0,0,0-.19-.028A1.078,1.078,0,0,1,856.357,372.073Zm-.244-.029h.026c-.008,0-.018,0-.026,0l0,0Zm10.67,19.485c-.125.23-.7.533-1.792.426-2.112-.21-4.931-2.345-5.8-3.118-.07-.069-7.072-6.876-8.908-9.063a5.457,5.457,0,0,1-1.344-2.779c.333-.145.629-.263.786-.314l.157.016a1.062,1.062,0,0,0,.8-.257,15.835,15.835,0,0,1,3.019-1.925,7.373,7.373,0,0,1,1.491-.582c.013.009.014.016.014.019h0a6.27,6.27,0,0,0,.763,2.554,5.772,5.772,0,0,0,3.384,2.389,1.06,1.06,0,0,0,.911-.2c.168-.134.358-.271.541-.394.48,2.36,1.177,5.609,1.639,6.979.417,1.235,1.764,2.936,3.481,5.031.3.362.574.7.812,1C866.834,391.436,866.8,391.494,866.783,391.529Z",
						transform: "translate(-832.164 -366.012)",
						fill: "#040505"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_356",
				"data-name": "Path 356",
				d: "M881.692,417.2h-3.167a1.056,1.056,0,0,0,0,2.111h3.167a1.056,1.056,0,1,0,0-2.111Z",
				transform: "translate(-828.745 -387.338)",
				fill: "#040505"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_357",
				"data-name": "Path 357",
				d: "M856.976,417.2h-7.727a1.056,1.056,0,0,0,0,2.111h7.727a1.056,1.056,0,0,0,0-2.111Z",
				transform: "translate(-814.921 -387.338)",
				fill: "#040505"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_358",
				"data-name": "Path 358",
				d: "M831.778,417.2h-3.167a1.056,1.056,0,0,0,0,2.111h3.167a1.056,1.056,0,0,0,0-2.111Z",
				transform: "translate(-805.176 -387.338)",
				fill: "#040505"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgStance);
export { ForwardRef as ReactComponent };
